// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2BAjc","time":"styles_time__24dwg"};